window.$J = jQuery.noConflict(); /* Sets window.$ to what it was when jQuery loaded, and returns jQuery */
var $J = window.$J;

import Vue from 'vue';

import es from 'moment/locale/es';

/** ROUTES & VUEX **/
import router from './router';
import store from './store/index.js';
import { sync } from 'vuex-router-sync';

import http from './api/Request';

import VuejsDialog from 'vuejs-dialog';
import VuejsDialogMixin from 'vuejs-dialog/dist/vuejs-dialog-mixin.min.js';
import 'vuejs-dialog/dist/vuejs-dialog.min.css';
// Tell Vue to install the plugin.
Vue.use(VuejsDialog);


import Modal from 'COMMONS/shared/Modal/ModalPlugin.js';
Vue.use(Modal);


import 'vue-tabs-component/docs/resources/tabs-component.css';

const unsync = sync(store, router);

import Snotify from 'vue-snotify';
Vue.use(Snotify);


import './imports/fontAwesome.js';
import './router/guards.js';

// V-Tooltip items
import { VTooltip, VPopover, VClosePopover } from 'v-tooltip';
Vue.directive( 'tooltip', VTooltip );
Vue.directive( 'popover', VPopover );
Vue.directive( 'close-popover', VClosePopover );

import Misc from "FILTERS/Misc/index.js";
import Numbers from "FILTERS/Numbers/index.js";
import Strings from "FILTERS/Strings/index.js";
import Tags from "FILTERS/Tags/index.js";

let filters = [
	...Misc,
	...Numbers,
	...Strings,
	...Tags
];

for(let f in filters) {
	let filter = filters[f];

	Vue.filter(filter.name, filter.action);
}

import iconClass from "./filters/icons.js";
Vue.filter( "iconClass", iconClass );

import { mappedColor, sectionColor } from "./filters/colors.js";
Vue.filter( "mappedColor", mappedColor );
Vue.filter( "sectionColor", sectionColor );

import denormalize from "./filters/denormalize.js";
Vue.filter( "denormalize", denormalize );

import localFilters from "./filters/DateTime/index.js";

for( let l in localFilters ) {
	Vue.filter( localFilters[ l ].name, localFilters[ l ].action );
}

// font-awesome
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
Vue.component('FontAwesomeIcon', FontAwesomeIcon);

// Import standard opens in new tab message
import { AriaNewTabMessage, DownloadFileAnchor } from 'COMMONS/HelpfulHTMLElements';
Vue.component( "AriaNewTabMessage", AriaNewTabMessage );
Vue.component( "DownloadFileAnchor", DownloadFileAnchor );

import i18n from '../locale/i18n.js';

i18n.locale = 'en-US';

Vue.prototype.$focusResetTab = function(text) {
	const resetTab = document.getElementById('reset-tab');
	if (resetTab) {
		resetTab.focus();
	}
};

import App from './App.vue';

new Vue({
	el: '#app',
	i18n,
	es,
	router,
	store,
	render: h => h(App)
});
